import * as React from "react";
function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { color = "#2E3092", height = 24, width = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      {...props}
      viewBox="0 0 11 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.47727 0.75L3.47727 6.75L0.75 4.02273"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgComponent;
